import styles from './eventosprivados.module.css'
import YouTube from 'react-youtube'

function Eventos() {
    return (
        <div id='eventosprivados' className={styles.clasesMain}>
            
            {/* --- HEADER --- */}
            <div className={styles.header}>
                <h3>CONCIERTOS - EVENTOS PRIVADOS</h3>
                <p>Música en vivo para celebraciones privadas y empresariales</p>
            </div>

            {/* --- SECCIÓN 1: INTRODUCCIÓN Y PROPUESTA --- */}
            <div className={styles.introContainer}>
                
                {/* Texto Principal */}
                <div className={styles.introTexto}>
                    <p>
                        Ofrecemos shows de tango personalizados para eventos privados y empresariales, 
                        adaptados al tipo de celebración, al espacio y a lo que el cliente desea transmitir.
                    </p>
                    <p>
                        Nos ocupamos de la coordinación general para que vos solo tengas que elegir el formato y disfrutar del evento.
                    </p>
                </div>

                {/* Lista de Beneficios (La Propuesta) */}
                <div className={styles.propuestaBox}>
                    <h4 className={styles.subtitulo}>
                        {/* Ícono de Nota Musical (SVG Nativo) */}
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            width="24" height="24" 
                            viewBox="0 0 24 24" 
                            fill="none" 
                            stroke="currentColor" 
                            strokeWidth="2" 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            className={styles.iconoTitulo}
                        >
                            <circle cx="6" cy="18" r="3"></circle>
                            <circle cx="18" cy="16" r="3"></circle>
                            <path d="M9 18V5l12-2v13"></path>
                        </svg>
                        Una propuesta simple y personalizada
                    </h4>
                    
                    <ul className={styles.listaBeneficios}>
                        {[
                            "Shows de tango a medida",
                            "Repertorio a elección del cliente",
                            "Diferentes formatos musicales",
                            "Posibilidad de sumar baile",
                            "Asesoramiento previo y trato directo"
                        ].map((item, index) => (
                            <li key={index}>
                                {/* Ícono de Check (SVG Nativo) */}
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="18" height="18" 
                                    viewBox="0 0 24 24" 
                                    fill="none" 
                                    stroke="currentColor" 
                                    strokeWidth="3" 
                                    strokeLinecap="round" 
                                    strokeLinejoin="round" 
                                    className={styles.iconoCheck}
                                >
                                    <polyline points="20 6 9 17 4 12"></polyline>
                                </svg>
                                {item}
                            </li>
                        ))}
                    </ul>
                    <p className={styles.fraseCierre}>
                        "Cada evento es único. El show se diseña especialmente para vos."
                    </p>
{/* --- SECCIÓN 2: FORMATOS DISPONIBLES --- */}
            
            {/* Margen grande para separar del cuadro de arriba */}
            <div className={styles.seccionFormatos}>
            <div className={styles.header}>
                <h3>FORMATOS DISPONIBLES</h3>
                <p>Elige la formación ideal para tu evento</p>
            </div>

            <div className={styles.clasesContainer}>
                
                {/* TARJETA 1: Show Solista */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Show Solista</h4>
                        <p className={styles.descripcionClase}>
                            Voz solista con pistas musicales de alta calidad. 
                            Ideal para eventos íntimos y celebraciones privadas donde el espacio es reducido.
                        </p>
                    </div>
                </div>

                {/* TARJETA 2: Dúo */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Dúo</h4>
                        <p className={styles.descripcionClase}>
                            Voz + músico acompañante de primer nivel. 
                            El equilibrio perfecto entre intimidad y presencia musical en vivo.
                        </p>
                    </div>
                </div>

                {/* TARJETA 3: Cuarteto */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Cuarteto</h4>
                        <p className={styles.descripcionClase}>
                            Formación instrumental completa con mayor riqueza sonora. 
                        </p>
                    </div>
                </div>

                {/* TARJETA 4: Orquesta */}
                <div className={styles.box}>
                    <div className={styles.boxContent}>
                        <h4 className={styles.tituloClase}>Orquesta</h4>
                        <p className={styles.descripcionClase}>
                            Propuesta de alto nivel artístico para eventos especiales y empresariales.
                        </p>
                    </div>
                </div>

            </div>

            {/* --- OPCIÓN EXTRA: BAILE (TEXTO SIMPLE) --- */}
                <div className={styles.baileContainer}>
                    <p className={styles.baileTexto}>
                        <span className={styles.baileTitulo}>
                            {/* Icono de Zapatos pequeño y sutil */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                                <circle cx="8.5" cy="7" r="4"></circle>
                                <polyline points="17 11 19 13 23 9"></polyline>
                            </svg>
                            ¿Querés sumar baile?
                        </span>
                        Se puede sumar una pareja de baile profesional, integrada de forma armónica al show musical para una experiencia visual completa.
                    </p>
                </div>
                </div>
            </div>
{/* --- SECCIÓN 3: LISTA DE EVENTOS Y CIERRE --- */}
            <div className={styles.finalSection}>

                <ul className={styles.eventosLista}>
                    {/* Mapeamos los items para que el código quede limpio */}
                    {[
                        "Cumpleaños", 
                        "Aniversarios", 
                        "Casamientos", 
                        "Eventos Empresariales", 
                        "Celebraciones Privadas"
                    ].map((item, index) => (
                        <li key={index} className={styles.eventoItem}>
                            {/* Check simple SVG */}
                            <svg className={styles.checkFinal} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            {item}
                        </li>
                    ))}
                </ul>
                <div className={styles.videoWrapper}>
                    <YouTube 
                        videoId="WFLACu4VxtY" // <--- CAMBIAR ESTO
                        className={styles.reproductor}
                        opts={{
                            width: '100%',
                            height: '100%',
                            playerVars: {
                                autoplay: 0,
                                showinfo: 0,
                                rel: 0, // Evita videos relacionados de otros canales
                            },
                        }}
                    />
                </div>
                <div className={styles.ctaContainer}>
                    <p className={styles.ctaTexto}>
                        "Cada evento se prepara de manera personalizada. Contactanos para armar una propuesta según tu evento y tus preferencias."
                    </p>
                    
                    {/* El botón de acción */}
                    <a href="https://wa.me/2215586164" className={styles.botonCTA}>
                        Chatear por WhatsApp
                    </a>
                </div>

            </div>
                </div>
            </div>
        
    )
}

export default Eventos 